import { useRouteError } from "react-router-dom";
import { UnexpectedError } from "src/components/UnexpectedError/UnexpectedError.tsx";

export const EditLayoutErrorBoundary = () => {
  const error = useRouteError() as any;

  return <UnexpectedError error={error} />;
};
